import { useSearchParams, Link } from "react-router-dom";

// 🧪 HML (20/10/2026): faz o papel da tela de retorno do VagasLume para testar a autorização sem depender do lado
// deles. Mostra o que o parceiro recebe no redirecionamento. Fora do HML, não existe (vira "não encontrada").
export default function TesteRetornoVagasLumePage() {
  const [q] = useSearchParams();
  if (!window.location.hostname.startsWith("hml.")) return null;
  const ok = q.get("resultado") === "autorizado";
  return (
    <div className="max-w-lg mx-auto px-4 py-10">
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1">Simulação: tela de retorno do VagasLume</p>
        <h1 className={`text-xl font-bold mb-3 ${ok ? "text-green-700" : "text-gray-700"}`}>{ok ? "✅ Conexão autorizada" : "Conexão não autorizada"}</h1>
        <p className="text-sm text-gray-600 mb-3">
          {ok ? "No fluxo real, o servidor do VagasLume pega o código abaixo e troca pelo token (POST assinado em /api/integracoes/vagaslume/token). A partir daí recebe os avisos de status."
              : "O candidato escolheu não conectar. Nenhum código foi gerado e nada foi compartilhado."}
        </p>
        <dl className="text-sm space-y-1 rounded-xl bg-gray-50 p-3 break-all">
          <div><dt className="inline font-semibold">resultado: </dt><dd className="inline">{q.get("resultado") || "—"}</dd></div>
          <div><dt className="inline font-semibold">estado: </dt><dd className="inline">{q.get("estado") || "—"}</dd></div>
          {ok && <div><dt className="inline font-semibold">código (vale 5 min, uso único): </dt><dd className="inline">{q.get("codigo") || "—"}</dd></div>}
        </dl>
        <Link to="/conta" className="mt-4 inline-block text-sm text-primary font-semibold hover:underline">Ver em Minha conta → Integrações</Link>
      </div>
    </div>
  );
}
